import { Card, Collapse } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { ReactComponent as CollapseSVG } from "go-core/images/svg/actions/collapse.svg";
import { VenueSettingsApi } from "../../../../../../../../../../../services/Api/Organization/types";
import { VenueSettingsItemApi } from "../../../../../../../../../../../services/Api/types";
import useCollapseCard from "../hooks/useCollapseCard";
import SettingsTable from "./SettingsTable";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
	title: string;
	types: VenueSettingsItemApi[];
	search: string;
}

export const DriversCard = ({ form, title, types, search }: Props) => {
	const { toggleCollapse, collapseIn, getCollapseIconStyles } = useCollapseCard(search, types);

	return (
		<Card className="venue-settings">
			<Card.Body>
				<div className="title" onClick={toggleCollapse}>
					<h5>{title}</h5>
					<CollapseSVG className={"collapse-icon"} style={getCollapseIconStyles()} />
				</div>
				<Collapse in={collapseIn}>
					<div>
						<table className={"table table-preview"}>
							<SettingsTable types={types} form={form} />
						</table>
					</div>
				</Collapse>
			</Card.Body>
		</Card>
	);
};
